/**
 * MedkitIcon — sanitized from `assets/newSvg/medkit.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function MedkitIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M10.8225,2.39262 C11.4231,1.63159 12.5769,1.63159 13.1775,2.39262 L19.7814,10.761 C20.3547,11.4875 20.3547,12.5125 19.7814,13.239 L13.1775,21.6074 C12.5769,22.3684 11.4231,22.3684 10.8225,21.6074 L4.21858,13.239 C3.64526,12.5125 3.64526,11.4875 4.21858,10.761 L10.8225,2.39262 Z"
        fill={color}
      />
    </Svg>
  );
}

export default MedkitIcon;
